module.exports = "https://static.moomoo.com/components/common-redpacket/images/no-crowd-nn.9344b1b71a.png";